//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

export const translations = {
  es: {
    nav: {
      home: "Inicio",
      catalog: "Catálogo",
      about: "Sobre Nosotros",
      services: "Servicios",
      contact: "Contáctanos"
    },
    categories: {
      ppe: "Elementos de Protección Personal EPP",
      tct: "Elementos Para Trabajo con Tensión", 
      enm: "Elementos Para Mantenimiento de Redes",
      mydTools: "Elementos de Medición y Detección",
      ept: "Equipos de Puesta a Tierra Temporal",
      heightWork: "Equipos Para Trabajo en Alturas",
      isolatedTools: "Herramienta Aislada 1000 VAC",
      manualandmotorTools: "Herramienta Manual Ferretería y Motorizada"
    },
    home: {
      sliderCatalog: "Ver Catálogo"
    },
    cart: {
      title: "Carrito de Compras",
      empty: "El carrito está vacío",
      total: "Total",
      checkout: "Cotizar Ahora!",
      login: "Ingresa tus Datos para Cotizar"
    },
    chatbot: {
      welcome: "¡Hola! Soy tu asistente virtual JGW. ¿En qué puedo ayudarte hoy?",
      options: ["Ver catálogo", "Información de productos", "Contactar soporte", "Acerca de la empresa"]
    },
    catalog: {
      search: "Buscar productos...",
      noResults: "No se encontraron productos",
      showingResults: "Mostrando resultados para:"
    }
  },
  en: {
    nav: {
      home: "Home",
      catalog: "Catalog", 
      about: "About Us",
      services: "Services",
      contact: "Contact Us"
    },
    categories: {
      ppe: "Personal Protective Equipment PPE",
      tct: "Live Line Work Equipment",
      enm: "Maintenance Electrical Networks Tools",
      mydTools: "Measurement and Detection Devices",
      ept: "Temporary Grounding Equipment",
      heightWork: "Height Wor Equipment",
      isolatedTools: "Isolated Tools 1000 VAC",
      manualandmotorTools: "Manual and Motorized Hardware Tools"
    },
    home: {
      sliderCatalog: "View Catalog"
    },
    cart: {
      title: "Shopping Cart",
      empty: "The cart is empty",
      total: "Total",
      checkout: "Get a quote now!",
      login: "Enter your details to get a quote"
    },
    chatbot: {
      welcome: "Hello! I'm your virtual assistant JGW. How can I help you today?",
      options: ["View catalog", "Product information", "Contact support", "About the company"]
    },
    catalog: {
      search: "Search products...",
      noResults: "No products found",
      showingResults: "Showing results for:"
    }
  }
};

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.